import React from "react";
import Logo from "./assets/deedat_1.png";

function App() {
  return (
    <div className=" bg-zinc-500 h-screen bg-[url('./assets/bg.jpg')] bg-cover md:bg-cover md:bg-top bg-center bg-no-repeat">
      <div className="h-[100%] bg-gradient-to-t from-slate-800">
        <div>
          <img src={Logo} className="w-[400px] rounded-full p-10" alt="logo" />
        </div>
        <div className="flex-col flex justify-start text-center items-center md:pt-42 pt-32  mt-20">
          <h1 className="md:text-[120px] text-6xl text-white font-bold md:pt-8 pt-2 font-bahnschrift tracking-wider">
            Coming Soon
          </h1>
          {/* <p className="text-white text-2xl md:tracking-widest tracking-wider pt-2 italic">
            "Style Speaks Louder Than Words: Unleash Your Fashion Statement!"
          </p> */}
          {/* <div className="flex flex-col md:mt-[-300px] mt-[-150px] px-4">
            <p class="block md:text-xl text-md font-bold text-white py-8 ">
              Share your Mobile Number for <br />
              Exclusive Updates and Promotions!
            </p>
          </div>
          <div className="flex justify-between gap-3 bg-white rounded-full h-10 items-center px-1 mx-5">
            <input
              className=" ml-2 px-4 w-48 border-slate-200 bg-transparent placeholder-slate-400 contrast-more:border-slate-400 contrast-more:placeholder-slate-500 rounded-full "
              placeholder="Enter Mobile Number"
            />
            <button className="bg-black text-sm text-white font-semibold hover:bg-gray-300 hover:text-black px-4 md:py-2 py-1.5 rounded-full relative ">
              Notify Me
            </button>
          </div> */}
        </div>
        <div className="w-full  text-white md:py-4 py-2 text-sm px-6 text-center absolute bottom-0">
          <p>&copy; 2023 DEEDAT IT. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

export default App;
